<template>
    <div class="w-full bg-transparent px-8 py-4 flex items-center justify-between rounded-lg shadow" data-testid="card-counter">
        <div class="w-full flex flex-row items-center justify-between" data-testid="card-body">
            <slot name="content">
                <h2 class="flex w-full justify-end text-6xl font-bold mx-3" data-testid="card-counter-value">
                    <div v-html="result" />
                </h2>
            </slot>
        </div>
    </div>
</template>
<script>
import { WidgetDataApi } from '@/api/widgetDataApi.ts'
import getDataIntervalMixin from '@/mixins/getDataIntervalMixin'

export default {
    mixins: [ getDataIntervalMixin ],
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            result: '',
        }
    },
    methods: {
        async getData () {
            try {
                this.result = await WidgetDataApi.getExternalData(this.data.EndPoint)
            } catch (e) {
                console.warn(e)
            }
        },
    },
    mounted () {
        this.getData()
    },
    watch: {
        data: {
            immediate: true,
            handler: function () {
                this.getDataWithRefreshInterval(this.getData)
            },
        },
    },
}
</script>
